var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"02.12.2024"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h3',[_vm._v("Die ersten Schuhe")]),_c('p',[_c('img',{attrs:{"src":require("@/assets/day2.jpeg")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }